"use client";

import { useEffect, useRef } from "react";
import { usePathname, useSearchParams } from "next/navigation";

export function GTMPageview() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    if (typeof window === "undefined" || !window.dataLayer) return;

    // Draft-preview routes must not be tracked (mirrors the GoogleTagManager guard).
    if (pathname === "/preview" || pathname.startsWith("/preview/")) return;

    const search = searchParams?.toString();
    const path = search ? `${pathname}?${search}` : pathname;

    window.dataLayer.push({
      event: "page_view",
      page_path: path,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [pathname, searchParams]);

  return null;
}
